module.exports = __webpack_public_path__ + "static/media/DWCaslon-Italic.47e15a79.woff2";